export default __webpack_public_path__ + "static/media/nurses-station-v5.36d40c08.png";